import React, { useState } from 'react'
import { Container, Grid, TextField } from '@mui/material'
// import _ from 'lodash'

// import useStyles from 'style'

const CppTool = () => {
  // const classes = useStyles()
  const [, setInputCode] = useState('')

  return (
    <>
      <Container maxWidth='lg' style={{ height: '70vh' }}>
        <Grid container spacing={4}>
          <Grid
            key='input'
            size={{
              xs: 8,
              md: 9
            }}
          >
            <div style={{ height: '35vh' }}>
              <TextField
                label='Input Code'
                multiline
                rows='20'
                variant='outlined'
                InputProps={{
                  style: { fontFamily: 'monospace', height: '30vh' }
                }}
                fullWidth
                margin='normal'
                onChange={e => setInputCode(e.target.value)}
              />
            </div>
            <div style={{ height: '35vh' }}>
              <TextField
                label='Output Code'
                multiline
                rows='20'
                variant='outlined'
                InputProps={{
                  style: { fontFamily: 'monospace', height: '30vh' }
                }}
                fullWidth
                margin='normal'
                onChange={e => setInputCode(e.target.value)}
              />
            </div>
          </Grid>
          <Grid
            key='input'
            size={{
              xs: 4,
              md: 3
            }}
          >
            <div style={{ height: '70vh' }}>
              <TextField
                label='Input List'
                multiline
                rows='20'
                variant='outlined'
                InputProps={{
                  style: { fontFamily: 'monospace', height: '65vh' }
                }}
                fullWidth
                margin='normal'
                onChange={e => setInputCode(e.target.value)}
              />
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default CppTool
